import { Box, Grid, GridItem, Text, Stat, StatLabel, StatNumber, StatHelpText, StatArrow, Heading, Skeleton, Flex, Divider } from '@chakra-ui/react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend } from 'chart.js';
import { getTicketDashboardStats, getVendasML, getGraficoSemanal, getGraficoMensal, getDadosVendasDashboard, getDadosReputacao, getGraficoUltimos30 } from "../services/api";
import React, { useState, useRef, useEffect } from 'react';
import Preloader from "../components/Preloader";
import SellerAccountInfoML from "../components/SellerAccountInfoML";
import ScrollToTop from "../components/ScrollToTop";
import BarChart from "../components/BarChart";
import TicketSummaryDashboard from "../components/TicketSummaryDashboard";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);

const Dashboard = () => {
    const dataFetchedRef = useRef(false);

    const [graficoSemanal, setGraficoSemanal] = useState([]);
    const [loadingGraficoSemanal, setLoadingGraficoSemanal] = useState(true);
    const [graficoMensal, setGraficoMensal] = useState(null);
    const [loadingGraficoMensal, setLoadingGraficoMensal] = useState(true);
    const [loadingGraficoBarras, setLoadingGraficoBarras] = useState(true);
    const [loadingDadosGerais, setLoadingDadosGerais] = useState(true);
    const [graficoUltimos30, setGraficoUltimos30] = useState(null);
    const [loadingGraficoUltimos30, setLoadingGraficoUltimos30] = useState(true);
    const [dados, setDados] = useState([]);
    const [dadosDash, setDadosDash] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingReputacao, setLoadingReputacao] = useState(true);
    const [sellerData, setSellerData] = useState([]);
    const [sellerData2, setSellerData2] = useState([]);

    // States para os dados do novo dashboard de tickets
    const [ticketStats, setTicketStats] = useState(null);
    const [loadingTicketStats, setLoadingTicketStats] = useState(true);

    useEffect(() => {
        // Roda apenas uma vez na montagem do componente
        if (dataFetchedRef.current === false) {
            // Funções de busca de dados
            const consultarVendas = () => {
                setLoading(true);
                setLoadingDadosGerais(false);
                var dataAtual = new Date();
                var ano = dataAtual.getFullYear();
                var mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
                var dia = String(dataAtual.getDate()).padStart(2, '0');
                var dataFormatadaInicial = `${ano}-${mes}-${dia}`;
                var consulta = "busca=" + "" + ",status=" + "confirmada-enviar-transito-concluida-cancelada" + ",data_inicial=" + dataFormatadaInicial + ",data_final=" + dataFormatadaInicial + ",mktplaces=0-1-2-3-4,fornecedores=morelate-vannucci-isapa-brcompany-autolatina-lng-cba-msam-blparts";

                getVendasML(consulta)
                    .then(responseVendas => {
                        if (responseVendas !== false) {
                            setDados(responseVendas);
                        }
                    })
                    .catch(err => console.error("Erro ao consultar vendas", err))
                    .finally(() => {
                        setLoading(false);
                        setLoadingDadosGerais(true);
                    });
            };

            const consultarGraficoSemanal = async () => {
                setLoadingGraficoSemanal(false);
                try {
                    const responseGraficoSemanal = await getGraficoSemanal();
                    if (responseGraficoSemanal) {
                        setGraficoSemanal(responseGraficoSemanal);
                    }
                } catch (error) {
                    console.error("Erro ao consultar gráfico semanal", error);
                } finally {
                    setLoadingGraficoSemanal(true);
                }
            };

            const consultarGraficoMensal = async () => {
                setLoadingGraficoMensal(false);
                try {
                    const responseGraficoMensal = await getGraficoMensal();
                    if (responseGraficoMensal) {
                        setGraficoMensal(responseGraficoMensal);
                    }
                } catch (error) {
                    console.error("Erro ao consultar gráfico mensal", error);
                } finally {
                    setLoadingGraficoMensal(true);
                }
            };

            const consultarGraficoUltimos30 = async () => {
                setLoadingGraficoUltimos30(false);
                try {
                    const responseGraficoUltimos30 = await getGraficoUltimos30();
                    if (responseGraficoUltimos30) {
                        setGraficoUltimos30(responseGraficoUltimos30);
                    }
                } catch (error) {
                    console.error("Erro ao consultar gráfico últimos 30 dias", error);
                } finally {
                    setLoadingGraficoUltimos30(true);
                }
            };

            const consultarDadosVendasDashboard = async () => {
                setLoadingReputacao(false);
                setLoadingGraficoBarras(false);
                try {
                    const responseDash = await getDadosVendasDashboard();
                    if (responseDash) {
                        setDadosDash(responseDash);
                    }
                } catch (error) {
                    console.error("Erro ao consultar dados do dashboard", error);
                } finally {
                    setLoadingReputacao(true);
                    setLoadingGraficoBarras(true);
                }
            };

            const consultarDadosReputacao = async () => {
                try {
                    const responseReputacao = await getDadosReputacao();
                    if (responseReputacao) {
                        setSellerData(responseReputacao.conta1);
                        setSellerData2(responseReputacao.conta2);
                    }
                } catch (error) {
                    console.error("Erro ao consultar dados de reputação", error);
                }
            };

            const fetchTicketStats = async () => {
                setLoadingTicketStats(true);
                try {
                    const stats = await getTicketDashboardStats();
                    setTicketStats(stats);
                } catch (error) {
                    console.error("Erro ao buscar estatísticas de tickets", error);
                } finally {
                    setLoadingTicketStats(false);
                }
            };

            // Executa todas as buscas
            consultarVendas();
            consultarGraficoSemanal();
            consultarGraficoMensal();
            consultarGraficoUltimos30();
            consultarDadosVendasDashboard();
            consultarDadosReputacao();
            fetchTicketStats(); // <-- Chama a nova função

            dataFetchedRef.current = true; // Marca que as buscas foram feitas
        }
    }, []); // Array de dependências vazio para rodar apenas uma vez


    // ... (Objetos de dados dos gráficos: salesData, salesDataMensal, salesDataUltimos30)
    const salesData = graficoSemanal
        ? {
            labels: graficoSemanal.labels, // Datas da semana
            datasets: [
                {
                    label: 'Vendas da Semana Atual',
                    data: graficoSemanal.vendasAtual,
                    fill: false,
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    borderColor: 'rgba(75,192,192,1)',
                    tension: 0.2,
                },
                {
                    label: 'Vendas da Semana Anterior',
                    data: graficoSemanal.vendasAnterior,
                    fill: false,
                    backgroundColor: '#CFA3FE',
                    pointBackgroundColor: '#4A2574',
                    borderColor: '#9E72C3',
                    tension: 0.2,
                }
            ],
        }
        : null;

    const salesDataMensal = graficoMensal ? {
        labels: graficoMensal.labels,
        datasets: [
            {
                label: 'Vendas do Mês Atual',
                data: graficoMensal.vendasAtual,
                fill: false,
                backgroundColor: 'rgba(75,192,192,0.4)',
                borderColor: 'rgba(75,192,192,1)',
                tension: 0.2,
            },
            {
                label: 'Vendas do Mês Anterior',
                data: graficoMensal.vendasAnterior,
                fill: false,
                backgroundColor: '#CFA3FE',
                pointBackgroundColor: '#4A2574',
                borderColor: '#9E72C3',
                tension: 0.2,
            },
        ],
    } : null;

    const salesDataUltimos30 = graficoUltimos30 ? {
        labels: graficoUltimos30.labels,
        datasets: [
            {
                label: 'Atual',
                data: graficoUltimos30.vendasAtual,
                fill: false,
                backgroundColor: 'rgba(75,192,192,0.4)',
                borderColor: 'rgba(75,192,192,1)',
                tension: 0.2,
            },
            {
                label: 'Anterior',
                data: graficoUltimos30.vendasAnterior,
                fill: false,
                backgroundColor: '#CFA3FE',
                pointBackgroundColor: '#4A2574',
                borderColor: '#9E72C3',
                tension: 0.2,
            },
        ],
    } : null;

    // ... (Objetos de opções dos gráficos: options, options2, options3)
    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'top',
            },
            tooltip: {
                enabled: true,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Dias da Semana',
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Valor Total Vendido (R$)',
                },
                beginAtZero: true,
            },
        },
    };

    const options2 = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'top',
            },
            tooltip: {
                enabled: true,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Dias do Mês',
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Valor Total Vendido (R$)',
                },
                beginAtZero: true,
            },
        },
    };

    const options3 = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'top',
            },
            tooltip: {
                enabled: true,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Dias do Mês',
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Valor Total Vendido (R$)',
                },
                beginAtZero: true,
            },
        },
    };

    const today = new Date();
    const formattedDate = today.toLocaleDateString('pt-BR', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });

    return (
        <>
            <ScrollToTop />
            <Box py={10} bg="white" minH="100vh">
                {loading && <Preloader />}
                <Box px={4} fontSize="xl">
                    <Box textAlign="center" ml={4} mb={4} fontSize="xl">
                        <Text color={"#F68633"} fontWeight={"bold"}>
                            DASHBOARD
                        </Text>
                    </Box>

                    <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={6} maxW="1200px" mx={{ base: "none", md: "auto" }} >
                        <GridItem bg="gray.100" p={4} borderRadius="md" h={{ base: "600px", md: "400px" }} >
                            <Stat w={{ base: "96%", md: "100%" }}>
                                <StatLabel mb={8}>Diário de Vendas</StatLabel>
                                <Heading ml={{ base: "0", md: "8" }} mb={4} color={"#F68633"}>Vendas</Heading>
                                <Text ml={{ base: "0", md: "8" }} fontSize="lg" mb={4}>{formattedDate}</Text>
                                <Skeleton isLoaded={loadingDadosGerais} height="200px">
                                    <Grid ml={{ base: "0", md: "8" }} templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={6}>
                                        <GridItem bg={"green.200"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Total de Vendido</StatLabel>
                                                <StatNumber>
                                                    {dados && dados.total_taga && dados.total_taga.total_vendido
                                                        ? `R$ ${dados.total_taga.total_vendido.toLocaleString('pt-BR', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}`
                                                        : 'R$ 0,00'}
                                                </StatNumber>
                                            </Stat>
                                        </GridItem>
                                        <GridItem bg={"gray.200"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Total de Vendas</StatLabel>
                                                <StatNumber>{dados && dados.total_taga && dados.total_taga.total_vendas ? dados.total_taga.total_vendas : 0}</StatNumber>
                                            </Stat>
                                        </GridItem>
                                        <GridItem bg={"yellow.200"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Vendas para verificar</StatLabel>
                                                <StatNumber>{dados && dados.total_taga && dados.total_taga.pendentes ? dados.total_taga.pendentes : 0}</StatNumber>
                                            </Stat>
                                        </GridItem>
                                        <GridItem bg={"red.200"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Vendas Canceladas</StatLabel>
                                                <StatNumber>{dados && dados.total && dados.total.canceladas ? dados.total.canceladas : 0}</StatNumber>
                                            </Stat>
                                        </GridItem>
                                    </Grid>
                                </Skeleton>
                            </Stat>
                        </GridItem>
                        <GridItem bg="gray.100" p={4} borderRadius="md" h={{ base: "700px", md: "400px" }} w={{ base: "100%" }}>
                            <Stat w={{ base: "96%", md: "100%" }}>
                                <StatLabel>Pendências</StatLabel>
                                <Text fontSize={{ base: "8px", sm: "10px" }} color={"gray.500"}>Nos últimos 14 Dias</Text>
                                <Skeleton isLoaded={loadingGraficoBarras} height="300px">
                                    <Grid mt={4} ml={{ base: "0", md: "8" }} templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={4}>
                                        <GridItem bg={"red.200"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Vendas Atrasadas</StatLabel>
                                                <StatNumber>{dadosDash && dadosDash.totalVendasAtrasadas ? dadosDash.totalVendasAtrasadas : 0}</StatNumber>
                                            </Stat>
                                        </GridItem>
                                        <GridItem bg={"red.200"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Furos de Estoque</StatLabel>
                                                <StatNumber>{dadosDash && dadosDash.totalFuroEstoque ? dadosDash.totalFuroEstoque : 0}</StatNumber>
                                            </Stat>
                                        </GridItem>
                                        <GridItem bg={"yellow.200"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Pendentes de Confirmação</StatLabel>
                                                <StatNumber>{dadosDash && dadosDash.totalPendentes ? dadosDash.totalPendentes : 0}</StatNumber>
                                            </Stat>
                                        </GridItem>
                                        <GridItem bg={"gray.400"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Problema de Envio</StatLabel>
                                                <StatNumber>{dadosDash && dadosDash.totalProblemaEnvio ? dadosDash.totalProblemaEnvio : 0}</StatNumber>
                                            </Stat>
                                        </GridItem>
                                        <GridItem bg={"purple.300"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Erro Precificação</StatLabel>
                                                <StatNumber>{dadosDash && dadosDash.totalErroPrecificacao ? dadosDash.totalErroPrecificacao : 0}</StatNumber>
                                            </Stat>
                                        </GridItem>
                                        <GridItem bg={"blue.400"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Outros Problemas</StatLabel>
                                                <StatNumber>{dadosDash && dadosDash.totalOutrosProblemas ? dadosDash.totalOutrosProblemas : 0}</StatNumber>
                                            </Stat>
                                        </GridItem>
                                    </Grid>
                                </Skeleton>
                            </Stat>
                        </GridItem>
                        <GridItem bg="gray.100" p={4} borderRadius="md" mt={{ base: "60px", md: "0" }} w={{ base: "100%" }}>
                            <Stat w={{ base: "96%", md: "100%" }}>
                                <StatLabel>Comparativo nos Últimos 30 Dias</StatLabel>
                                <Skeleton isLoaded={loadingGraficoUltimos30} height="100px">
                                    <Grid ml={{ base: "0", md: "8" }} mt={8} templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={6}>
                                        <GridItem bg={"#4BC0C0"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Total Atual</StatLabel>
                                                <StatNumber>{graficoUltimos30 && graficoUltimos30.totalVendasAtual
                                                    ? `R$ ${graficoUltimos30.totalVendasAtual.toLocaleString('pt-BR', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}`
                                                    : 'R$ 0,00'}</StatNumber>
                                            </Stat>
                                        </GridItem>
                                        <GridItem bg={"#9E72C3"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Total Anterior</StatLabel>
                                                <StatNumber>{graficoUltimos30 && graficoUltimos30.totalVendasAnterior
                                                    ? `R$ ${graficoUltimos30.totalVendasAnterior.toLocaleString('pt-BR', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}`
                                                    : 'R$ 0,00'}</StatNumber>
                                            </Stat>
                                        </GridItem>
                                    </Grid>
                                </Skeleton>
                                <Box ml={{ base: "0", md: "8" }} px={4} pb={4} mt={{ base: "110px", md: "4" }}>
                                    <Flex mb={"50"} flexDirection={{ base: "column", md: "row", lg: "row" }}>
                                        <Box mt={0} width={{ base: "100%", md: "100%", lg: "100%" }} height={{ base: "400px", md: "300px", lg: "300px" }}>
                                            <Text fontSize="xl" mb={2}>Vendas Durante 30 Dias</Text>
                                            <Skeleton isLoaded={loadingGraficoUltimos30} height="300px">
                                                {graficoUltimos30 && (
                                                    <Line
                                                        data={salesDataUltimos30}
                                                        options={{
                                                            ...options3,
                                                            maintainAspectRatio: false,
                                                            responsive: true,
                                                        }}
                                                        height={null}
                                                    />
                                                )}
                                            </Skeleton>
                                        </Box>
                                    </Flex>
                                </Box>
                            </Stat>
                        </GridItem>
                        <GridItem bg="gray.100" p={4} borderRadius="md" mt={{ base: "20px", md: "0" }} w={{ base: "100%" }}>
                            <Stat w={{ base: "96%", md: "100%" }}>
                                <StatLabel>Status das Vendas</StatLabel>
                                <Text fontSize={"10px"} color={"gray.500"} >Nos últimos 14 Dias</Text>

                                <Skeleton isLoaded={loadingGraficoBarras} height="300px">
                                    <Box>
                                        {
                                            dadosDash && dadosDash.totalVendasPorStatus &&
                                            <BarChart arrayStatusPedidos={dadosDash.totalVendasPorStatus} />
                                        }
                                    </Box>
                                </Skeleton>
                            </Stat>
                        </GridItem>
                        <GridItem bg="gray.100" p={4} borderRadius="md" mt={{ base: "20px", md: "0" }} w={{ base: "100%" }}>
                            <Stat w={{ base: "96%", md: "100%" }}>
                                <StatLabel>Comparativo Semanal</StatLabel>
                                <Skeleton isLoaded={loadingGraficoSemanal} height="100px">
                                    <Grid ml={{ base: "0", md: "8" }} mt={8} templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={6}>
                                        <GridItem bg={"#4BC0C0"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Total Semana Atual</StatLabel>
                                                <StatNumber>
                                                    {dadosDash && dadosDash.totalVendasSemanaAtual
                                                        ? `R$ ${dadosDash.totalVendasSemanaAtual.toLocaleString('pt-BR', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}`
                                                        : 'R$ 0,00'}
                                                </StatNumber>
                                            </Stat>
                                        </GridItem>
                                        <GridItem bg={"#9E72C3"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Total Semana Anterior</StatLabel>
                                                <StatNumber>{dadosDash && dadosDash.totalVendasSemanaAnterior
                                                    ? `R$ ${dadosDash.totalVendasSemanaAnterior.toLocaleString('pt-BR', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}`
                                                    : 'R$ 0,00'}</StatNumber>
                                            </Stat>
                                        </GridItem>
                                    </Grid>
                                </Skeleton>
                                <Box ml={{ base: "0", md: "8" }} px={4} pb={4} mt={{ base: "110px", md: "4" }}>
                                    <Flex mb={"50"} flexDirection={{ base: "column", md: "row", lg: "row" }}>
                                        <Box mt={0} width={{ base: "100%", md: "100%", lg: "100%" }} height={{ base: "400px", md: "300px", lg: "300px" }}>
                                            <Text fontSize="xl" mb={2}>Vendas Durante a Semana</Text>
                                            <Skeleton isLoaded={loadingGraficoSemanal} height="300px">
                                                {graficoSemanal && (
                                                    <Line
                                                        data={salesData}
                                                        options={{
                                                            ...options,
                                                            maintainAspectRatio: false,
                                                            responsive: true,
                                                        }}
                                                        height={null}
                                                    />
                                                )}
                                            </Skeleton>
                                        </Box>
                                    </Flex>
                                </Box>
                            </Stat>
                        </GridItem>
                        <GridItem bg="gray.100" p={4} borderRadius="md" mt={{ base: "20px", md: "0" }} w={{ base: "100%" }}>
                            <Stat w={{ base: "96%", md: "100%" }}>
                                <StatLabel>Comparativo Mensal</StatLabel>
                                <Skeleton isLoaded={loadingGraficoMensal} height="100px">
                                    <Grid ml={{ base: "0", md: "8" }} mt={8} templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={6}>
                                        <GridItem bg={"#4BC0C0"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Total Mês Atual</StatLabel>
                                                <StatNumber>{dadosDash && dadosDash.totalVendasMesAtual
                                                    ? `R$ ${dadosDash.totalVendasMesAtual.toLocaleString('pt-BR', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}`
                                                    : 'R$ 0,00'}</StatNumber>
                                            </Stat>
                                        </GridItem>
                                        <GridItem bg={"#9E72C3"} p={4} borderRadius="md">
                                            <Stat>
                                                <StatLabel>Total Mês Anterior</StatLabel>
                                                <StatNumber>{dadosDash && dadosDash.totalVendasMesAnterior
                                                    ? `R$ ${dadosDash.totalVendasMesAnterior.toLocaleString('pt-BR', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}`
                                                    : 'R$ 0,00'}</StatNumber>
                                            </Stat>
                                        </GridItem>
                                    </Grid>
                                </Skeleton>
                                <Box ml={{ base: "0", md: "8" }} px={4} pb={4} mt={{ base: "110px", md: "4" }}>
                                    <Flex mb={"50"} flexDirection={{ base: "column", md: "row", lg: "row" }}>
                                        <Box mt={0} width={{ base: "100%", md: "100%", lg: "100%" }} height={{ base: "400px", md: "300px", lg: "300px" }}>
                                            <Text fontSize="xl" mb={2}>Vendas Durante o Mês</Text>
                                            <Skeleton isLoaded={loadingGraficoMensal} height="300px">
                                                {graficoMensal && (
                                                    <Line
                                                        data={salesDataMensal}
                                                        options={{
                                                            ...options2,
                                                            maintainAspectRatio: false,
                                                            responsive: true,
                                                        }}
                                                        height={null}
                                                    />
                                                )}
                                            </Skeleton>
                                        </Box>
                                    </Flex>
                                </Box>
                            </Stat>
                        </GridItem>
                    </Grid>
                </Box>

                <Flex justify={"center"} align={"center"}>
                    <Skeleton isLoaded={loadingReputacao} height={{ base: "auto" }} width={"90%"}>
                        <Flex mt={10} flexDirection={{ base: "column", md: "row" }} justify={"center"} align={"center"}>
                            <Box ml={{ base: "0", md: "8" }} w={{ base: "100%", md: "45%" }} mr={{ base: "0", md: "12" }}>
                                {
                                    sellerData && Object.keys(sellerData).length > 0 && <SellerAccountInfoML sellerData={sellerData} conta={1} />
                                }
                            </Box>

                            <Box w={{ base: "100%", md: "45%" }} mt={{ base: "6", md: "0" }}>
                                {
                                    sellerData2 && Object.keys(sellerData2).length > 0 && <SellerAccountInfoML sellerData={sellerData2} conta={2} />
                                }
                            </Box>
                        </Flex>
                    </Skeleton>
                </Flex>

                <Box maxW="1100px" mx="auto" mt={8} mb={8}>
                    <TicketSummaryDashboard stats={ticketStats} loading={loadingTicketStats} />
                </Box>
            </Box>
        </>
    );
};

export default Dashboard;